// src/debugger.js
export function setupDebugFromQuery() {
  const params = new URLSearchParams(window.location.search);
  const enabled = params.has('debug');
  const forceIOS = params.has('forceIOS');
  if (!enabled) return { enabled, forceIOS, log: () => {} };

  const logs = [];
  const log = (type, data) => {
    const item = { ts: new Date().toISOString(), type, data };
    logs.push(item);
    const el = document.getElementById('__dbg-log');
    if (el) {
      el.textContent = JSON.stringify(logs, null, 2);
      el.scrollTop = el.scrollHeight;
    }
    // Envie para seu backend se quiser ter registro centralizado:
    // fetch('/log-js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(item) });
  };

  // Overlay leve na tela
  const wrap = document.createElement('div');
  wrap.id = '__dbg-wrap';
  wrap.style.cssText = `
    position:fixed; z-index:999999; bottom:0; right:0; width: min(480px, 95vw); max-height: 60vh;
    background: rgba(0,0,0,.85); color:#0f0; font: 12px/1.4 monospace; border:1px solid #0f0; border-right:0; border-bottom:0;
    display:flex; flex-direction:column;
  `;
  const hdr = document.createElement('div');
  hdr.style.cssText = 'display:flex; align-items:center; gap:8px; padding:6px 8px; background:#111; color:#0f0; border-bottom:1px solid #0f0;';
  hdr.innerHTML = `
    <strong>DEBUG</strong>
    <span style="opacity:.8">| ${navigator.userAgent}</span>
    <span style="margin-left:auto; cursor:pointer; color:#f66" id="__dbg-close">[fechar]</span>
  `;
  const info = document.createElement('div');
  info.style.cssText = 'padding:6px 8px; border-bottom:1px solid #0f0;';
  const pre = document.createElement('pre');
  pre.id = '__dbg-log';
  pre.style.cssText = 'margin:0; padding:8px; overflow:auto; white-space:pre-wrap; flex:1;';
  wrap.appendChild(hdr);
  wrap.appendChild(info);
  wrap.appendChild(pre);
  document.body.appendChild(wrap);

  document.getElementById('__dbg-close').onclick = () => wrap.remove();

  // Info do ambiente (útil pra iPhone)
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
  const net = navigator.connection ? {
    downlink: navigator.connection.downlink,
    effectiveType: navigator.connection.effectiveType,
    rtt: navigator.connection.rtt
  } : null;

  info.innerText = [
    `isIOS: ${isIOS}`,
    `forceIOS: ${forceIOS}`,
    `viewport: ${vw}x${vh}`,
    `time: ${new Date().toLocaleString()}`,
    net ? `network: ${JSON.stringify(net)}` : 'network: n/a'
  ].join(' | ');

  // Captura erros
  window.onerror = (msg, src, line, col, err) => log('onerror', { msg, src, line, col, stack: err && err.stack });
  window.onunhandledrejection = (e) => log('unhandledrejection', { reason: String(e.reason), stack: e.reason && e.reason.stack });

  // Monkeypatch de fetch p/ logar requests/responses
  const _fetch = window.fetch;
  window.fetch = async (...args) => {
    const [input, init] = args;
    const out = { url: (typeof input === 'string') ? input : (input?.url), init };
    log('fetch:start', out);
    try {
      const res = await _fetch(...args);
      const headers = {};
      res.headers.forEach((v, k) => headers[k] = v);
      log('fetch:done', { url: out.url, status: res.status, headers });
      return res;
    } catch (err) {
      log('fetch:error', { url: out.url, error: String(err) });
      throw err;
    }
  };

  // Helper pra testar PDF (HEAD/GET com Range para ver headers)
  async function testPdf(url) {
    log('pdf:test:start', { url });
    try {
      // Tenta solicitar 1 byte para checar Accept-Ranges/Content-Type (requer CORS ok)
      const res = await fetch(url, { headers: { Range: 'bytes=0-0' } });
      const headers = {};
      res.headers.forEach((v, k) => headers[k] = v);
      log('pdf:test:done', { url, ok: res.ok, status: res.status, headers });
    } catch (e) {
      log('pdf:test:error', { url, error: String(e) });
    }
  }

  return { enabled, forceIOS, log, testPdf };
}